'use strict';

import $ from 'jquery';
import { defaultOptions } from '../tippy-util';
import { getOptionsFromDataset } from '../../../util/dom';
import { menuTippyInstances, closeAllExceptThis } from './shared-objects';

/**
 * @param {JQuery} $trigger
 * @param {JQuery} $container
 * @param {JQuery} $content
 * @param menuDirection
 * @param {Partial<import('tippy.js').Props>} options
 */
export default async ($trigger, $container, $content, menuDirection, options) => {

	// Import the tippy lib lazily
	const { default: tippy } = await import('tippy.js');
	const $oldTrigger = $trigger;
	let triggerTarget = null;
	let $appendTo = $container[0];
	let widePopperModifiers = [];
	const fullWidthMenuTypes = ['tabbed', 'expanded', 'horizontal'];
	const autoWidthMenuTypes = ['tree', 'dropdown'];

	let trigger = 'mouseenter';
	if (mpro.config?.desktop?.menu?.trigger === 'click') {
		trigger = 'click';

		// Prevent default on click trigger
		$trigger.on('click', 'a', function(e){
			e.preventDefault();
		});
	}

	if ($trigger.is(fullWidthMenuTypes.map(v => '.header__menu-item--' + v).join(','))) {
		triggerTarget = $trigger[0];
		const $menuContainerWide = $container.find('[data-menu-wide-overlayer-container]').length ? $container.find('[data-menu-wide-overlayer-container]') : $container.find('#header_menu_wide');
		$trigger = $menuContainerWide;
		$appendTo = $menuContainerWide[0];
		widePopperModifiers = [
			{
				name: 'applyDimensions',
				enabled: true,
				phase: 'beforeWrite',
				fn: (data) => {
					data.state.styles.popper.width = menuDirection === 'vertical' ? 'auto' : '100%';
					data.state.styles.popper.maxWidth = menuDirection === 'vertical' ? ('calc(100vw - ' + data.state.elements.reference.getBoundingClientRect().right + 'px)') : '100%';
					data.state.styles.popper.maxHeight = menuDirection === 'vertical' ? '100%' : ('calc(100vh - ' + data.state.elements.reference.getBoundingClientRect().bottom + 'px)');
					const tabbedIndex = data.state.elements.popper.querySelector(".menu-tabbed__index");
					if (tabbedIndex) {
						tabbedIndex.style.maxHeight = menuDirection === 'vertical' ? '100%' : ('calc(100vh - ' + data.state.elements.reference.getBoundingClientRect().bottom + 'px)');
					}
					data.state.styles.popper.overflowX = 'hidden';
					data.state.styles.popper.overflowY = 'auto';
				},
			}
		];
	}

	if ($trigger.is('.header__menu-item--tree') || $trigger.is('.header__menu-item--dropdown')) {
		widePopperModifiers = [
			{
				name: 'applyMaxHeightOnBox',
				enabled: true,
				phase: 'beforeWrite',
				fn: (data) => {
					const tippyBox = $(data.state.elements.popper).find('.tippy-box')[0];
					tippyBox.style.maxHeight = ('calc(100vh - ' + data.state.elements.reference.getBoundingClientRect().bottom + 'px - 1rem)');
					tippyBox.style.overflowX = 'visible';
					tippyBox.style.overflowY = 'auto';
				},
			}
		];
	}

	// @ts-ignore
	const instance = tippy($trigger[0], {

		// Merge with default config
		...defaultOptions,

		...getOptionsFromDataset(triggerTarget || $trigger[0], 'tippy', true),

		appendTo: $appendTo,
		triggerTarget: triggerTarget,
		content: (reference) => $content[0],
		placement: menuDirection === 'vertical' ? 'right-start' : 'bottom-start',
		offset: (menuDirection === 'vertical' && $trigger.is(autoWidthMenuTypes.map(v => '.header__menu-item--' + v).join(','))) ? [0, 16] : defaultOptions.offset,
		// onTrigger: closeAllExceptThis,
		onMount: closeAllExceptThis,
		trigger: trigger,
		popperOptions: {
			modifiers: [
				...defaultOptions.popperOptions.modifiers,
				{
					name: 'preventOverflow',
					enabled: true,
					options: {
						rootBoundary: $appendTo,
						padding: 0,
					},
				},
				...widePopperModifiers,
			],
		},
		onShow: (instance) => {
			const firstSubtarget = $(instance.props.content).find('.menu-tabbed__index .menu-tabbed__item:first [data-target]');
			if (firstSubtarget.length) {
				firstSubtarget.data('instance').show();
			}
			$oldTrigger.addClass('header__menu-item--opened');
		},
		onHide: (instance) => {
			$oldTrigger.removeClass('header__menu-item--opened');
		},

		// Merge with provided options
		...options
	});

	$oldTrigger.data('instance', instance);

	// Add to tippy menu instances list to simulate singleton
	menuTippyInstances.add(instance);

	return instance;
};
